// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-install[data-v-31f4ef16]:hover{cursor:pointer}.badge-install[data-v-31f4ef16]{display:flex;margin-left:10px}.badge-install[data-v-31f4ef16]:hover{border-color:var(--lightest)}.badge-install>I[data-v-31f4ef16]{line-height:inherit}.badge-install[data-v-31f4ef16]:focus{outline:0}", ""]);
// Exports
module.exports = exports;
